// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"styles-module--heroSection--1guqN"};